import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-events-speakers',
    templateUrl: './events-speakers.component.html',
    styleUrls: ['./events-speakers.component.scss']
})
export class EventsSpeakersComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    singleScientistItemBox: Scientist[] = [
        {
            img: 'assets/img/speaker/img1.png',
            title: 'Merv Adrian',
            subTitle: 'Data Management',
            facebookLink: '#',
            twitterLink: '#',
            linkedinLink: '#',
            instagramLink: '#',
        },
        {
            img: 'assets/img/speaker/img2.png',
            title: 'Kirk Borne',
            subTitle: 'Data Management',
            facebookLink: '#',
            twitterLink: '#',
            linkedinLink: '#',
            instagramLink: '#',
        },
        {
            img: 'assets/img/speaker/img3.png',
            title: 'Carla Gentry',
            subTitle: 'Data Management',
            facebookLink: '#',
            twitterLink: '#',
            linkedinLink: '#',
            instagramLink: '#',
        },
        {
            img: 'assets/img/speaker/img4.png',
            title: 'Marie Curie',
            subTitle: 'Data Management',
            facebookLink: '#',
            twitterLink: '#',
            linkedinLink: '#',
            instagramLink: '#',
        },
        {
            img: 'assets/img/speaker/img5.png',
            title: 'Alina Sophia',
            subTitle: 'Data Management',
            facebookLink: '#',
            twitterLink: '#',
            linkedinLink: '#',
            instagramLink: '#',
        },
        {
            img: 'assets/img/speaker/img6.png',
            title: 'Liam Oliver',
            subTitle: 'Data Management',
            facebookLink: '#',
            twitterLink: '#',
            linkedinLink: '#',
            instagramLink: '#',
        }
    ]

}
class Scientist {
    img : string;
    title : string;
    subTitle : string;
    facebookLink : string;
    twitterLink : string;
    linkedinLink : string;
    instagramLink : string;
}